import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon";
import CheckIcon from "@heroicons/react/24/outline/CheckIcon";

const struggles = [
  "Conversations buried among dozens of chats",
  "Re-explaining your training every time",
  "AI gets confused in long conversations",
  "Figuring out the right way to ask",
];

const solutions = [
  "Your coach remembers everything",
  "Pick up right where you left off",
  "Answers stay accurate, always",
  "Just ask like you're talking to a real coach",
];

export function ComparisonSection() {
  return (
    <section className="py-12 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Powered by ChatGPT. Built for runners.
          </h2>
          <p className="text-lg text-gray-600">
            Same AI quality you'd get from ChatGPT - without the hassle of
            managing conversations, re-explaining your data, or crafting the
            perfect prompt.
          </p>
        </div>

        {/* Comparison grid */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* Left column - struggles */}
          <div className="bg-white rounded-2xl p-8 border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-500 mb-6 uppercase tracking-wide">
              Using ChatGPT directly
            </h3>
            <ul className="space-y-4">
              {struggles.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <XMarkIcon className="w-4 h-4 text-red-500" />
                  </div>
                  <span className="text-gray-600">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right column - solutions */}
          <div className="bg-gradient-to-br from-brand-600 to-brand-700 rounded-2xl p-8 shadow-lg shadow-brand-600/25">
            <h3 className="text-lg font-semibold text-brand-100 mb-6 uppercase tracking-wide">
              Using RunLens
            </h3>
            <ul className="space-y-4">
              {solutions.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-emerald-400/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <CheckIcon className="w-4 h-4 text-emerald-300" />
                  </div>
                  <span className="text-white">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
}
